import React from 'react';

const HireOnDemand = () => {
    const roles = [
        { type: "BIM Coordinator", group: "coord" },
        { type: "BIM Executive", group: "exec" },
        { type: "BIM Executive", group: "exec" },
        { type: "BIM Modeler", group: "model" },
        { type: "BIM Modeler", group: "model" },
        { type: "BIM Coordinator", group: "coord" },
        { type: "BIM Executive", group: "exec" },
        { type: "BIM Executive", group: "exec" },
        { type: "BIM Modeler", group: "model" },
        { type: "BIM Modeler", group: "model" },
        { type: "BIM Coordinator", group: "coord" },
        { type: "BIM Executive", group: "exec" },
        { type: "BIM Executive", group: "exec" },
        { type: "BIM Modeler", group: "model" },
        { type: "BIM Modeler", group: "model" }
    ];

    return (
        <section className="hire-on-demand">
            <div className="on-demand-container">
                <div className="on-demand-header">
                    <h2 className="on-demand-title">
                        <span className="text-primary">Hire Your On-</span>Demand BIM Specialist
                    </h2>
                    <p className="on-demand-subtitle">
                        Access our pool of ready-to-work BIM professionals. Whether you need short-term 
                        coordination support or long-term modeling expertise, we have the right talent for your project.
                    </p>
                </div>
                <div className="on-demand-grid">
                    {roles.map((item, index) => (
                        <div key={index} className="role-card-wrapper">
                            <div className="role-card">
                                <div className="role-circle"></div>
                                <span className="role-name">{item.type}</span>
                            </div>
                            <div className="role-card-shadow"></div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default HireOnDemand;
